import React from 'react';

import { useHistory } from 'react-router-dom';

import {getSearchParamsFromUrl} from '@common/react/utils/FIltersParamsFromUrl/FiltersParamsFromUrl';

import NewConcatForm from '@app/components/UI/ContactForm/NewContactForm';

import '@app/scss/pages/contactUs.scss';

const ContactUs: React.FC = () => {
	const history = useHistory();
	const params = getSearchParamsFromUrl(history.location);
	const isDemo = !!params.demo;
	return (
		<div className="contact-us">
			{isDemo ? null : <div className="blue-dark-border request-demo-block" style={{borderLeft: 'none', borderRight: 'none'}}>
				<div className="blue-dark-block skew-block white-text">
					<h2 className="margin-0">
						Contact Us
					</h2>
				</div>
				<div className="flex-row">
					<div>
						1649 North Military Trail
						<br/>
						West Palm Beach, FL 33409
						<br/>
						<br/>
						<a href="tel:+15615125313">(561) 512-5313</a>
						<br/>
						<a href="mailto:sales@executivetags.com">sales@executivetags.com</a>
					</div>
					<div>
						<a
							href="https://www.facebook.com/executivetags/"
							target="_blank"
							className="footer9_social-link w-inline-block"
						>
							<div className="footer9_social-icon w-embed">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="21"
									viewBox="0 0 20 21"
									fill="none"
								>
									<path
										d="M15.0002 2.16666H12.5002C11.3951 2.16666 10.3353 2.60564 9.55388 3.38704C8.77248 4.16845 8.3335 5.22825 8.3335 6.33332V8.83332H5.8335V12.1667H8.3335V18.8333H11.6668V12.1667H14.1668L15.0002 8.83332H11.6668V6.33332C11.6668 6.11231 11.7546 5.90035 11.9109 5.74407C12.0672 5.58779 12.2791 5.49999 12.5002 5.49999H15.0002V2.16666Z"
										fill="#22458D"
									/>
								</svg>
							</div>
							<div>Facebook</div>
						</a>
						<a
							href="https://www.instagram.com/executivetags/"
							target="_blank"
							className="footer9_social-link w-inline-block"
						>
							<div className="footer9_social-icon w-embed">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="21"
									viewBox="0 0 20 21"
									fill="none"
								>
									<path
										d="M14.1665 2.16666H5.83317C3.53198 2.16666 1.6665 4.03214 1.6665 6.33332V14.6667C1.6665 16.9678 3.53198 18.8333 5.83317 18.8333H14.1665C16.4677 18.8333 18.3332 16.9678 18.3332 14.6667V6.33332C18.3332 4.03214 16.4677 2.16666 14.1665 2.16666Z"
										fill="#22458D"/>
									<path
										d="M13.3332 9.97499C13.436 10.6685 13.3176 11.3768 12.9946 11.9992C12.6717 12.6215 12.1608 13.1262 11.5345 13.4414C10.9083 13.7566 10.1985 13.8663 9.50633 13.7549C8.81411 13.6435 8.17464 13.3167 7.67887 12.821C7.1831 12.3252 6.85628 11.6857 6.74489 10.9935C6.63351 10.3013 6.74322 9.59157 7.05844 8.9653C7.37366 8.33903 7.87833 7.82811 8.50066 7.50519C9.12299 7.18228 9.8313 7.06381 10.5248 7.16666C11.2323 7.27156 11.8872 7.60121 12.3929 8.10691C12.8986 8.61261 13.2283 9.26755 13.3332 9.97499Z"
										fill="#22458D"/>
									<path
										d="M14.5832 5.91666H14.5915M5.83317 2.16666H14.1665C16.4677 2.16666 18.3332 4.03214 18.3332 6.33332V14.6667C18.3332 16.9678 16.4677 18.8333 14.1665 18.8333H5.83317C3.53198 18.8333 1.6665 16.9678 1.6665 14.6667V6.33332C1.6665 4.03214 3.53198 2.16666 5.83317 2.16666ZM13.3332 9.97499C13.436 10.6685 13.3176 11.3768 12.9946 11.9992C12.6717 12.6215 12.1608 13.1262 11.5345 13.4414C10.9083 13.7566 10.1985 13.8663 9.50633 13.7549C8.81411 13.6435 8.17464 13.3167 7.67887 12.821C7.1831 12.3252 6.85628 11.6857 6.74489 10.9935C6.63351 10.3013 6.74322 9.59157 7.05844 8.9653C7.37366 8.33903 7.87833 7.82811 8.50066 7.50519C9.12299 7.18228 9.8313 7.06381 10.5248 7.16666C11.2323 7.27156 11.8872 7.60121 12.3929 8.10691C12.8986 8.61261 13.2283 9.26755 13.3332 9.97499Z"
										stroke="white"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</div>
							<div>Instagram</div>
						</a>
						<a
							href="https://www.linkedin.com/company/executive-tag-&amp;-title-svcs.-inc."
							className="footer9_social-link w-inline-block"
						>
							<div className="footer9_social-icon w-embed">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="21"
									viewBox="0 0 20 21"
									fill="none"
								>
									<path
										d="M13.3332 7.16666C14.6593 7.16666 15.931 7.69344 16.8687 8.63112C17.8064 9.5688 18.3332 10.8406 18.3332 12.1667V18H14.9998V12.1667C14.9998 11.7246 14.8242 11.3007 14.5117 10.9881C14.1991 10.6756 13.7752 10.5 13.3332 10.5C12.8911 10.5 12.4672 10.6756 12.1547 10.9881C11.8421 11.3007 11.6665 11.7246 11.6665 12.1667V18H8.33317V12.1667C8.33317 10.8406 8.85995 9.5688 9.79764 8.63112C10.7353 7.69344 12.0071 7.16666 13.3332 7.16666Z"
										fill="#22458D"/>
									<path d="M4.99984 7.99999H1.6665V18H4.99984V7.99999Z" fill="#22458D"/>
									<path
										d="M3.33317 5.49999C4.25365 5.49999 4.99984 4.7538 4.99984 3.83332C4.99984 2.91285 4.25365 2.16666 3.33317 2.16666C2.4127 2.16666 1.6665 2.91285 1.6665 3.83332C1.6665 4.7538 2.4127 5.49999 3.33317 5.49999Z"
										fill="#22458D"
									/>
								</svg>
							</div>
							<div>LinkedIn</div>
						</a>
					</div>
				</div>
			</div>}
			<NewConcatForm demo={isDemo}/>
		</div>
	);
};

export default ContactUs;